import resizeFile from "./resizeImage";
import { post } from "service/api";

const handleUpload = async (apiPath, defaultImages) => {
  if (defaultImages.length > 0) {
    const newdata = defaultImages.map(async (file) => {
      if (file.originFileObj) {
        const base = await resizeFile(file.originFileObj);
        return { name: file.name, base: base };
      } else return { name: null, base: "" };
    });

    Promise.all(newdata)
      .then(function (results) {
        results.map((img) => {
          if (img.name) {
            fetch(img.base)
              .then((res) => res.blob())
              .then((blob) => {
                const file = new File([blob], img.name, { mimetype: "image" });
                const formData = new FormData();
                formData.append("upImage.png", file);
                console.log(file, formData, img.name);
                for (const [key, value] of formData.entries()) {
                  console.log(key, value);
                }
                post(apiPath, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                });
              });
          }
        });
      })
      .then(() => {
        return true;
      })
      .catch((e) => {
        console.log("Error uploading images:", e);
        return false;
      })
      .finally(() => {
        console.log("save images");
      });
  }
};

export default handleUpload;
